module.exports = __webpack_public_path__ + "static/media/wetting.839a0dbc.mp4";